import { review, ui, updateUi, type MobileTab } from '../state/store';
import { outputItems, previewDoc, runFailed } from '../run/output';
import { IconCode, IconMessage, IconTerminal } from './Icons';

const TABS: { id: MobileTab; label: string; Icon: typeof IconCode }[] = [
  { id: 'prompt', label: 'Prompt', Icon: IconMessage },
  { id: 'code', label: 'Code', Icon: IconCode },
  { id: 'output', label: 'Output', Icon: IconTerminal },
];

export function MobileTabs() {
  const current = ui.value.mobileTab;
  const hasError = runFailed.value;
  const hasOutput = outputItems.value.length > 0 || previewDoc.value !== null;
  const reviewing = review.value !== null;
  return (
    <nav class="mobile-tabs" aria-label="Sections">
      {TABS.map(({ id, label, Icon }) => (
        <button
          key={id}
          type="button"
          class={`mobile-tab${current === id ? ' active' : ''}`}
          aria-current={current === id ? 'page' : undefined}
          onClick={() => updateUi({ mobileTab: id, outputOpen: id === 'output' ? true : ui.value.outputOpen })}
        >
          <Icon size={20} />
          <span>{label}</span>
          {id === 'code' && reviewing && <span class="dot dot-ember" aria-label="Proposal waiting for review" />}
          {id === 'output' && hasOutput && <span class={`dot${hasError ? ' dot-error' : ''}`} aria-hidden="true" />}
        </button>
      ))}
    </nav>
  );
}
